import classJoin from 'classjoin';
import {h} from 'preact';
import AbstractVisualStep, {AbstractVisualStepState} from './AbstractVisualStep';
import fetchVisualFloor from './asyncActions/fetchVisualFloor';
import fetchVisualOverview from './asyncActions/fetchVisualOverview';
import fetchVisualSection from './asyncActions/fetchVisualSection';
import MobileVisualItemsList from './MobileVisualItemsList';
import {
	setBuilding,
	setSection,
	setStep,
} from './Store/creators/visualData';
import {dispatch, getState} from './Store/index';
import {StateVisualMapItem, StateVisualStep} from './Store/State';

/**
 * Component Properties.
 */
interface MobileVisualOverviewProps
{
	/** Внутреннее название вида */
	view: string;
	/** Следующий вид */
	nextView: string;
	/** Путь до изображения */
	image: string;
	/** Карта областей */
	map: StateVisualMapItem[];
}

/**
 * Component State.
 */
type MobileVisualOverviewState = AbstractVisualStepState;

/**
 * Мобильный вариант общего экрана.
 */
class MobileVisualOverview
	extends AbstractVisualStep<MobileVisualOverviewProps, MobileVisualOverviewState>
{
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		super.componentDidMount();
		
		const {visualData: {step, prevStep, overview}} = getState();
		
		if ( step < prevStep )
		{
			fetchVisualOverview( overview.view );
		}
	}
	
	/**
	 * Render component.
	 */
	public render(
		{image, map}: MobileVisualOverviewProps,
		{aspectRatioLessThanImage}: MobileVisualOverviewState,
	): JSX.Element
	{
		return (
			<section class="overview">
				<header>
					<h2>Выберите секцию</h2>
				</header>
				<div
					class={classJoin(
						{
							[AbstractVisualStep.CLASS_INVERT_ASPECT]: aspectRatioLessThanImage,
						},
						['map'],
					)}
					ref={this.refMapContainer}
				>
					<img
						src={image}
						alt=""
					/>
					<svg
						width="1920" height="1080"
						viewBox="0 0 1920 1080"
					>
						{/* <use xlinkHref="/images/choose-visual/compasses.svg#overview" /> */}
						{map
							.filter( ( area ) => ( area.available !== 0 ) )
							.map(
								( area ) => (
									<path
										d={area.path}
										data-target={area.target}
										data-available={area.available}
										onClick={this.onAreaClick}
									/>
								),
							)
						}
					</svg>
				</div>
				<MobileVisualItemsList
					label="Секция"
					items={map}
					onChange={this.onItemListChange}
				/>
			</section>
		);
	}
	
	/**
	 * При нажатии на область.
	 */
	private onAreaClick = ( event: Event ): void =>
	{
		const target = event.target as Element;
		const targetId = target.getAttribute( 'data-target' );
		
		if ( !targetId )
		{
			return;
		}
		
		const available = target.getAttribute( 'data-available' ) || '0';
		
		if ( available === '0' )
		{
			return;
		}
		
		this.setSection( targetId );
	}
	
	/**
	 * При изменении значения списка элементов.
	 */
	private onItemListChange = ( value: string ): void =>
	{
		this.setSection( value );
	}
	
	/**
	 * Выбирает секцию.
	 * 
	 * @param value Номер секции.
	 */
	private setSection( value: string ): void
	{
		dispatch(
			setBuilding(
				{
					building: '1',
					view: this.props.view,
					nextView: '',
					image: '',
					map: [],
				},
			),
		);
		dispatch(
			setSection(
				{
					section: value,
					view: this.props.view,
					nextView: '',
					image: this.props.image,
					map: [],
				},
			),
		);
		fetchVisualSection( value, this.props.view );
		
		dispatch( setStep( StateVisualStep.FLOOR ) );
		fetchVisualFloor( 2 );
	}
}

/**
 * Module.
 */
export {
	MobileVisualOverview as default,
	MobileVisualOverviewProps,
	MobileVisualOverviewState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/MobileVisualOverview.tsx